module.exports = __webpack_public_path__ + "guanao-pc/static/media/mp.7fcfa7b4.jpg";